import React from 'react'
import logo1 from './images/Asset 3.png'
import logo2 from './images/Asset 4.png'
import logo3 from './images/Asset 5.png'
import logo4 from './images/Asset 6.png'
import sideone from './images/ppc.jpeg'
import sidesmall1 from './images/side-low-ads1.png'
import sidesmall2 from './images/side-low-ads2.png'
export default function Ads_Spend() {
  return (
    <>
      <div className="container ads-main-container">
        <div className="row row-cols-4 ads-main-row">
            <div className="col ads-main-col">
                <div className="ads-main-img">
                    <img src={logo1} alt="" />
                </div>
            </div>
            <div className="col ads-main-col">
                <div className="ads-main-img">
                    <img src={logo2} alt="" />
                </div>
            </div>
            <div className="col ads-main-col">
                <div className="ads-main-img">
                    <img src={logo3} alt="" />
                </div>
            </div>
            <div className="col ads-main-col">
                <div className="ads-main-img">
                    <img src={logo4} alt="" />
                </div>
            </div>

        </div>
        
      </div>
      <div className="container main1-ads-container">
      <div className="row row-cols-2 main-contain-area-row">
            <div className="col side-big-img">
                <img src={sideone} alt="" />
            </div>
            <div className="col side-contain-area">
                <div className="logo-area">
                        <div className="img-area14">
                            <img src={sidesmall1} alt="" />
                        </div>
                        <div className="img-area14">
                            <img src={sidesmall2} alt="" />
                        </div>
                </div>
                <div className="main-ads-heading">
                    <h1>Unlock the Potential of PPC Management Services</h1>
                </div>
                <div className="main-ads-para">
                    <p>
                    As the digital landscape rapidly expands, competition intensifies across all sectors from small businesses and eCommerce stores to large franchises and startups. Everyone is vying for attention online, exploring new advertising strategies to convert visitors into loyal customers.
                    </p>
                    <p>
                    But with more options come greater challenges. Many businesses still struggle to reach the right audience, despite having access to a wide range of tools and platforms. This lack of visibility often leads to stagnant growth and wasted marketing efforts.
                    </p>
                    <p>
                    If you're aiming for quick campaign momentum and a strong return on investment (ROI), Pay-Per-Click (PPC) advertising is a powerful solution. With the right strategy, you maintain full control over your marketing spend, reach high-intent users, and drive real, measurable results.
                    </p>
                </div>
            </div>
        </div>
      </div>
    </>
  )
}
